import { VoiceCommand } from "../command-registry";
import { VoiceIntent, ParsedIntent, normalize } from "../intent-parser";
export interface NavigateCommandDependencies {
  push: (path: string) => void;
}

const ROUTE_MAP = [
  {
    keys: ["inicio", "pagina inicial", "catalogo"],
    route: "/",
  },
  {
    keys: [
      "servicos",
      "carta de servicos",
      "cartas de servicos",
      "carta de servico",
    ],
    route: "/carta-de-servicos",
  },
  {
    keys: ["noticias", "informacoes"],
    route: "/noticias",
  },
  {
    keys: ["secretarias e orgaos", "secretarias", "orgaos", "governo"],
    route: "/secretarias-e-orgaos",
  },
];

export function resolveRoute(value: string): string | null {
  const normalized = normalize(value);

  const match = ROUTE_MAP.find((entry) =>
    entry.keys.some((key) => normalized === key || normalized.includes(key))
  );

  return match?.route ?? null;
}

export function createNavigateCommand(
  deps: NavigateCommandDependencies
): VoiceCommand {
  return {
    intent: VoiceIntent.NAVIGATE,
    description: 'Navega para uma seção do portal. Ex: "ir para secretarias"',

    validate: (parsed: ParsedIntent): boolean => {
      return resolveRoute(parsed.value) !== null;
    },

    execute: (parsed: ParsedIntent): void => {
      const route = resolveRoute(parsed.value);

      if (!route) {
        return;
      }

      deps.push(route);
    },
  };
}
